import React, { Component } from 'react';
import '../Login/login.css';
import Root from '../Root/root';
import {API_URL, DOMAIN_COOKIE} from '../../constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import ButtonLoader from '../Elements/Button/button';
import cookie from 'react-cookies';
import {GetMenuHeader, getRoles} from '../../functions';
import $ from 'jquery';


export default class Login extends Component {

    constructor(props){
        super(props);
        this.state = {
            loader : true,
            enable: false,
            label : 'Ingresar',
            username: '',
            pwd: '',
            loading: false,
            login:{
                hasError:false,
                message:""
            }
        } 
        this.callFunctionButton = this.callFunctionButton.bind(this);
     }

     callFunctionButton = (event) => {
        this.setState({
            loading:true, 
            loader:false, 
            label: 'Validando...', 
            enable: true
        });

        var self = this;
        var rootScreen=[];
        var username = document.getElementById('username').value;
        var pwd = document.getElementById('pwd').value
        var formData = `{username: "${username}", pwd: "${pwd}"}`;

        const url = `${API_URL}AuthorizationUX/`;

        axios.get( url +'?email=' + username)
        .then(response => response.data)
        .then((data) => { 
            if (data.hasData && data.result.nUsuCodigo > 0){

                    const user  = data.result;

                    // axios.get(API_URL + `OpcionUX/GetOptionsByUser/${data.result.nUsuCodigo}`)
                    // .then((result) => {     

                    // let optdata = result.data.result;
                    // optdata = optdata.map((item) => item.sUrl);
                    // console.log("OPTIONS", optdata);
                    // Autenticacion AD

                    if (data.result.nUsuTipoAutenticacion === 884){
                        axios.post(url, JSON.stringify(formData), { 
                            headers: {
                                'Content-Type': 'application/json; charset=UTF-8' ,
                                'Accept': 'application/json'
                            }
                        }).then((result)=> {
                            //BRYAN CHAUCA
                            console.log("Usuario recibiendo respuesta");
                            if (result.data.result.validate) 
                                {
                                localStorage.setItem("user", null); // Clear
                                cookie.remove('user', { path: '/'}) 
                                // localStorage.setItem("useropt", null);
                                
                                var roles   = getRoles(data.result);
                                
                                if(roles.length > 0 || user.Tusu_EsSuperAdmin) {

                                    console.log("set roles successfuly");
                                    toast.success('Validación correcta, ingreso al sistema');
                                    
                                    // localStorage.setItem("useropt", JSON.stringify(optdata));

                                    //GET MENU
                                    //const urlmenu = API_URL + `OpcionUX/GetOptionsByUser/${user.nUsuCodigo}`;
                                    //axios.get(urlmenu).then(response => response.data)
                                    //.then(async (resmenu) => {

                                        //SAVE USER
                                        localStorage.setItem("user", JSON.stringify(user));
                                        cookie.save('user', JSON.stringify(user),{ path: '/'})

                                        this.setState({loading:false});
                                        //var menu = await GetMenuHeader(resmenu.result);
                                        //console.log('datamenu', menu);

                                        //SAVE MENU
                                        //localStorage.setItem("usermenu", JSON.stringify(menu));
                                        //cookie.save('usermenu', JSON.stringify(menu),{ path: '/'})

                                        rootScreen.push(
                                            <Root
                                                appContext={self.props.appContext} 
                                                key="root-screen"
                                            />
                                        );
                                        self.props.appContext.setState({
                                            loginPage:[],
                                            rootScreen:rootScreen
                                        });                                        
                                }else{
                                    this.setState({loading:false});
                                    //toast.error('Error de Autenticación: No tiene permisos para acceder al CMS');
                                    localStorage.setItem("user", null);
                                    cookie.remove('user', { path: '/'})
                                    
                                    let messageError = {
                                        hasError:true,
                                        message:'Error de Autenticación: No se le permite el acceso al CMS ya que no tiene ningún rol asignado'
                                    }

                                    this.setState({loading:false, login:messageError});
                                }
                            }else{
                                    //toast.error('Error de Autenticación: Credenciales incorrectas o email no válido');
                                    localStorage.setItem("user", null);
                                    cookie.remove('user', { path: '/' })
                                    
                                    let messageError = {
                                        hasError:true,
                                        message:'Error de Autenticación: Credenciales incorrectas o email no válido'
                                    }

                                    this.setState({
                                        loading:false, 
                                        login:messageError
                                    });
                            }
                        }).catch( error => {
                            localStorage.setItem("user", null);
                            cookie.remove('user', { path: '/' })

                            let messageError = {
                                hasError:true,
                                message:'Error de Autenticación: Error de conexión'
                            }

                            this.setState({loading:false, login:messageError});
                        }); 
                    }else{
                        
                        const urlBD = `${API_URL}SecurityUX/`;
                        axios.get(urlBD + `${username}/${pwd}`).then((result)=> {     
                            if(result.data.result.bValidate){
                                
                                var roles = getRoles(data.result);
                                console.log(roles);

                                if (roles.length > 0 ||  data.result.Tusu_EsSuperAdmin) {

                                    this.setState({
                                        loading:false
                                    });

                                    toast.success('Validación correcta, ingreso al sistema');
                                    
                                    localStorage.setItem("user", JSON.stringify(data.result));
                                    // localStorage.setItem("useropt", JSON.stringify(optdata));
                                    cookie.save('user', JSON.stringify(data.result), { path: '/' })
                                    rootScreen.push(<Root appContext={self.props.appContext} key="root-screen"/>);
                                    self.props.appContext.setState({loginPage:[],rootScreen:rootScreen});
                                
                                } else {

                                    localStorage.setItem("user", null);
                                    cookie.remove('user', { path: '/'})
                                    
                                    let messageError = {
                                        hasError:true,
                                        message:'Error de Autenticación: No tiene permisos para acceder al CMS'
                                    }

                                    this.setState({
                                        loading:false, 
                                        login:messageError
                                    });
                                }
                                
                            
                            } else {
                                //toast.error('Error de Autenticación: Credenciales incorrectas o email no válido');
                                localStorage.setItem("user", null);
                                cookie.remove('user', { path: '/' })

                                let messageError = {
                                    hasError:true,
                                    message:'Error de Autenticación: Credenciales incorrectas o email no válido'
                                }

                                this.setState({loading:false, login:messageError});
                            }
                        }).catch(error=> {
                            let messageError = {
                                hasError:true,
                                message:'Error de Autenticación: Error de conexión'
                            }
                            //toast.error('Error de Autenticación: Error de conexión');
                            cookie.remove('user', { path: '/' })
                            this.setState({loading:false, login:messageError});
                        }); 
                    }
            }else{
                // Usuario no encontrado
                let messageError = {
                    hasError:true,
                    message:'Error de Autenticación: Usuario no registrado o email no válido'
                }

                //toast.error('Error de Autenticación: Usuario no registrado o email no válido');
                this.setState({loading:false, login:messageError});
            }

            this.setState({loading:false, loader:true, label: 'Ingresar', enable: false});
        })
        .catch(error => {
            this.setState({loading:false, loader:true, label: 'Ingresar', enable: false});
        });

         
     }

    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.callFunctionButton();
        }
    }

render() {
  return (

    <div className="divContenedor_Sesion">
        <div className="divRowContenedor_Sesion">
            <div className="divTitulo_Sesion">
            Inicio de sesión
            </div>
            <div className={"divForm_Session " + (this.state.login.hasError ? "textAlertaError" : "")}>   

            {
                this.state.login.hasError ?
                <div>
                    <b>{this.state.login.message}</b>   
                  
                </div> : null
            }
            
            <p>
            <input id="username" name="username" type="text" placeholder="* Correo electrónico" required="" />
            </p>		
            <p>
            <input type="password" id="pwd" name="pwd" onKeyDown={this._handleKeyDown} placeholder="* Contraseña" required="" />
            </p>
                * Ingrese su correo electrónico y la contraseña de su computadora de PROMPERÚ.
            <br />
            <br />
            <p>
                <button disabled={this.state.enable} class="reset submit" type="submit" onClick={(event) => this.callFunctionButton(event)} >
                    <span id="spinner" hidden={this.state.loader} class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> &nbsp;
                    <span id="lblLogin">{this.state.label}</span>
                </button>

            </p>
  
            </div>
        </div>
    </div>
  );
  }
};

